<template>

  <v-autocomplete
    :menu-props="menuProps"
    @input="openMenu = false"
    @click.native="openMenu = true"
    v-click-outside="closeMenu"
    ref="autoComplete"
    :class="{
    'has-value': !!value,
    mobile: !$vuetify.breakpoint.mdAndUp,
    'selection-scope-defined': !!$scopedSlots.selection,

  }"
    :value="value"
    hide-details="'auto'"
    v-bind="$attrs"
    class="vcita-auto-complete"
    v-on="$listeners"
    :style="{
      color: `${brandBgColor} !important`
    }"
  >
    <template v-if="$scopedSlots['prepend-item']" v-slot:prepend-item>
      <slot name="prepend-item">
      </slot>
    </template>
    <template v-if="$scopedSlots.label" v-slot:label="item">
      <slot name="label" v-bind="item">
      </slot>
    </template>

    <template v-if="$scopedSlots.selection" v-slot:selection="item">
      <slot name="selection" v-bind="item">
      </slot>
    </template>

    <template v-if="$scopedSlots.item" v-slot:item="item">
      <slot name="item" v-bind="item">
      </slot>
    </template>

  </v-autocomplete>

</template>

<script>
  import ServiceListItem from "@/modules/bookings/components/common/ServicesListSelect/ServiceListItem.vue"
  import ClickOutside from 'vue-click-outside'

  export default {
    components: {
      ServiceListItem,
    },
    directives: {
      ClickOutside
    },
    props: {
      value: {
        type: [Object, String],
        required: false,
      },
    },
    watch: {
      openMenu: {
        handler(newVal) {
          this.$emit('menu-toggled', newVal);
        }
      },
    },
    data() {
      return {
        openMenu: false
      }
    },
    methods: {
      closeMenu(event) {
        let elem = event.path.findIndex((o) => o.className ? o.className.includes('v-menu__content') : false);
        if (elem === -1)
          this.openMenu = false
      },
    },
    computed: {
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
      menuProps() {
        let contentClass = 'vcita-auto-complete-menu-content '
        if(this.$attrs['menu-props']) {
          if(this.$attrs['menu-props'].contentClass) {
            contentClass += this.$attrs['menu-props'].contentClass
          }
        }
        return {
          value: this.openMenu,
          'offset-y': true,
          ...this.$attrs['menu-props'],
          'close-on-click': true,
          ...{contentClass}
        }
      },
      popupItem() {
        return this.$refs.autoComplete && this.$refs.autoComplete.$refs.menu.$refs.content
      }
    },

  }

</script>

<style lang="scss" scoped>
  @import '@/assets/scss/abstract/_i18n-mixins';
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .vcita-auto-complete {
    font-family: var(--primary-font-family);
    border-radius: 6px;
    padding: 0;
    margin: 0;
    &.has-value {
      ::v-deep {
        input {
          min-width: 0;
          max-width: 0;
        }
      }
    }
    &.v-input--is-focused.v-select--is-menu-active {
      ::v-deep {
        .v-input__slot {
          border: 1px solid var(--brand-color-secondary) !important;
          box-shadow: 0 0 0 3px rgba(var(--brand-color-secondary-rgb), 0.4);
        }

        input {
          min-width: 100%;
        }
      }
    }


    ::v-deep {
      .v-select__selections {
        height: 100%;
        flex-wrap: nowrap;
      }
      .v-input__append-inner {
        margin-top: auto;
        margin-bottom: auto;
      }
      .v-input__icon--append {
        font-size: 16px !important;
        i {
          color: rgba(0, 0, 0, 0.4) !important;
          cursor: pointer;
        }

        @include md-and-up {
          font-size: unset;
          i {
            color: inherit;
          }
        }
      }
      fieldset {
        border: solid 1px rgba(0, 0, 0, 0.12);
        display: none;
        padding: 12px 0;
        transition: border-color 0.1s;
        color: inherit !important;
        @include md-and-up {
          display: block;
        }
      }
      .v-label--active {
        font-size: 14px;
        transform: translateY(-100%) scale(0.85);
      }
    }

    &.v-input:hover:not(.error--text), &.v-input--is-focused {
      ::v-deep {
        fieldset {
          border-color: currentColor;
        }
      }
    }
    &.v-input--is-label-active:not(.selection-scope-defined) {
      ::v-deep {
        .v-select__selections {
            transform: translateY(10px);
        }
      }
    }
    ::v-deep {
      .v-select__selection, .v-list-item__content {
        text-transform: revert;
      }
      .v-input__slot {
        min-height: 52px !important;
        border-radius: 6px;
        background-color: #fff !important;
        position: relative !important;
        border: solid 1px rgba(0, 0, 0, 0.12);
        transition: border-color 0.1s !important;
        padding-left: 12px;
        padding-right: 12px;
        &:hover {
          border: 1px solid #757575;
        }
        &:before, &:after {
          display: none;
        }
      }
    }

  }

</style>
